module.exports = __webpack_public_path__ + "static/img/programme.91ce575b.png";